<template>
  <div class="picker">
    <a-row :gutter="12">
      <a-col :span="12">
        <span class="label"> {{ label }} </span>
        <CustomScrollbar class="panel" :height="`${height}px`">
          <slot name="left" />
        </CustomScrollbar>
      </a-col>
      <a-col :span="12">
        <span class="label"> {{ selectedLabel }} </span>
        <CustomScrollbar class="panel panel--high" :height="`${height}px`">
          <slot name="right" />
        </CustomScrollbar>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

export default {
  components: {
    CustomScrollbar,
  },
  props: {
    label: {
      required: true,
      type: String,
    },
    selectedLabel: {
      required: false,
      type: String,
      default: "Seleccionados",
    },
    height: {
      required: false,
      type: Number,
      default: 320,
    },
  },
};
</script>

<style lang="sass" scoped>
.picker
  background-color: $gray-2
  border: $border-normal
  padding: 8px 20px
  user-select: none
  color: $gray-9

.panel
  padding: 12px
  margin: 4px 0
  border-radius: 2px
  border: $border-normal
  background-color: $white

  &--high
    padding: 4px 8px

.label
  font-weight: 600
</style>
